import { render, staticRenderFns } from "./company-details.vue?vue&type=template&id=55e35342"
import script from "./company-details.vue?vue&type=script&lang=js"
export * from "./company-details.vue?vue&type=script&lang=js"
import style0 from "./company-details.vue?vue&type=style&index=0&id=55e35342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports